










































import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: {
    NumberInput
  }
})
export default class OneService extends Vue {
  @Prop({ default: "" }) label1!: string;
  @Prop({ default: "" }) label2!: string;
  @Prop({ default: 0 }) unitprice!: number;
  @Prop({ default: 0 }) days!: number;
  @Prop({ default: 0 }) totalmoney!: number;
  @Prop({ default: "0px" }) left!: string;
  @Prop({ default: "日" }) unit!: string;
  @Prop({ default: 1 }) lines!: number;
  @Prop({ default: "12px" }) label1FontSize!: string;
  @Prop({ default: "12px" }) label2FontSize!: string;

  get Unitprice() {
    return this.unitprice;
  }
  set Unitprice(newValue) {
    if (this.Days) {
      this.Totalmoney = newValue * this.Days;
    }
    this.updateUnitprice(newValue);
  }

  get Days() {
    return this.days;
  }
  set Days(newValue) {
    if (this.Unitprice) {
      this.Totalmoney = newValue * this.Unitprice;
    }
    this.updateDays(newValue);
  }

  public get Totalmoney() {
    return this.totalmoney;
  }
  public set Totalmoney(newValue) {
    this.updateCost(newValue);
    this.changealltotal();
  }

  @Emit("update:unitprice")
  public updateUnitprice(newValue: unknown) {
    return newValue;
  }

  @Emit("update:days")
  public updateDays(newValue: unknown) {
    return newValue;
  }

  @Emit("update:totalmoney")
  public updateCost(newValue: unknown) {
    return newValue;
  }

  @Emit("changealltotal")
  public changealltotal() {
    return;
  }
}
